'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _valuesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/values');
var lodash = require('lodash');
var helperFunctions = require('../utils/helper-functions.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _valuesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_valuesInstanceProperty);

/**
 * Schema triplet describing one source-edge-target triplet in schema.
 *
 * @export
 * @interface SchemaTriplet
 */
exports.Triplet = void 0;
(function (_Triplet) {
  function getAllTriplets(schema) {
    var _context;
    var result = [];
    _forEachInstanceProperty__default["default"](_context = schema.vertexTypes).call(_context, function (source) {
      var _context2;
      _forEachInstanceProperty__default["default"](_context2 = schema.edgeTypes).call(_context2, function (edge) {
        var _context3;
        _forEachInstanceProperty__default["default"](_context3 = schema.vertexTypes).call(_context3, function (target) {
          var _context4, _context5;
          // 1. Following edge direction triplet.
          if (_filterInstanceProperty__default["default"](_context4 = edge.fromToVertexTypePairs).call(_context4, function (pair) {
            return pair.from === source.name && pair.to === target.name;
          }).length > 0) {
            result.push({
              source: source.name,
              edge: edge.name,
              target: target.name
            });
          }
          // 2. If it's an undirected edge, and following reverse edge direction.
          if (!edge.directed && _filterInstanceProperty__default["default"](_context5 = edge.fromToVertexTypePairs).call(_context5, function (pair) {
            return pair.to === source.name && pair.from === target.name;
          }).length > 0) {
            result.push({
              source: source.name,
              edge: edge.name,
              target: target.name
            });
          }
        });
      });
    });
    return result;
  }
  _Triplet.getAllTriplets = getAllTriplets;
  function refineBySource(triplets, vertexTypes) {
    return _filterInstanceProperty__default["default"](triplets).call(triplets, function (triplet) {
      return _includesInstanceProperty__default["default"](vertexTypes).call(vertexTypes, triplet.source);
    });
  }
  _Triplet.refineBySource = refineBySource;
  function refineByEdge(triplets, edgeTypes) {
    return _filterInstanceProperty__default["default"](triplets).call(triplets, function (triplet) {
      return _includesInstanceProperty__default["default"](edgeTypes).call(edgeTypes, triplet.edge);
    });
  }
  _Triplet.refineByEdge = refineByEdge;
  function refineByTarget(triplets, vertexTypes) {
    return _filterInstanceProperty__default["default"](triplets).call(triplets, function (triplet) {
      return _includesInstanceProperty__default["default"](vertexTypes).call(vertexTypes, triplet.target);
    });
  }
  _Triplet.refineByTarget = refineByTarget;
  function intersectTriplets(leftTriplets, rightTriplets) {
    return lodash.intersectionWith(leftTriplets, rightTriplets, lodash.isEqual);
  }
  _Triplet.intersectTriplets = intersectTriplets;
  function unionTriplets(leftTriplets, rightTriplets) {
    return lodash.unionWith(leftTriplets, rightTriplets, lodash.isEqual);
  }
  _Triplet.unionTriplets = unionTriplets;
  function excludeTriplets(leftTriplets, rightTriplets) {
    return helperFunctions.HelperFunctions.exclude(leftTriplets, rightTriplets);
  }
  _Triplet.excludeTriplets = excludeTriplets;
  function getSourceTypes(triplets) {
    var result = new _Set__default["default"]([]);
    _forEachInstanceProperty__default["default"](triplets).call(triplets, function (triplet) {
      return result.add(triplet.source);
    });
    return _Array$from__default["default"](_valuesInstanceProperty__default["default"](result).call(result));
  }
  _Triplet.getSourceTypes = getSourceTypes;
  function getEdgeTypes(triplets) {
    var result = new _Set__default["default"]([]);
    _forEachInstanceProperty__default["default"](triplets).call(triplets, function (triplet) {
      return result.add(triplet.edge);
    });
    return _Array$from__default["default"](_valuesInstanceProperty__default["default"](result).call(result));
  }
  _Triplet.getEdgeTypes = getEdgeTypes;
  function getTargetTypes(triplets) {
    var result = new _Set__default["default"]([]);
    _forEachInstanceProperty__default["default"](triplets).call(triplets, function (triplet) {
      return result.add(triplet.target);
    });
    return _Array$from__default["default"](_valuesInstanceProperty__default["default"](result).call(result));
  }
  _Triplet.getTargetTypes = getTargetTypes;
})(exports.Triplet || (exports.Triplet = {}));
